import { Routes, RouterModule } from "@angular/router";

import * as admin from "./routes/admin.route";
import * as andrews from "./routes/andrews.route";
import * as onboarding from "./routes/onboarding.route";

import { HomePageComponent } from "./shared/components/home-page/home-page.component";
import { LoginPageComponent } from './shared/components/login-page/login-page.component';
import { IsLoggedIn } from './shared/guards/is-logged-in';
import { ConfirmationPageComponent } from './shared/components/confirmation-page/confirmation-page.component';
import { MyProfilePageComponent } from './shared/components/my-profile-page/my-profile-page.component';
import { ResetPasswordPageComponent } from './shared/components/reset-password-page/reset-password-page.component';

export const routes: Routes = [
  { path: "welcome", component: HomePageComponent, canActivate: [false] },
  { path: "users/confirmation", component: ConfirmationPageComponent },
  { path: "myprofile", component: MyProfilePageComponent, canActivate: [IsLoggedIn] },
  { path: "users/change_password", component: ResetPasswordPageComponent },
  { path: "", component: LoginPageComponent },
  { path: ":registerSuccess", component: LoginPageComponent },
  { path: ":registerSuccess/:email", component: LoginPageComponent },
  { path: '**', redirectTo: '/' }
];

export const routing = RouterModule.forRoot(
  [
    ...admin.routes,
    ...andrews.routes,
    ...onboarding.routes,
    ...routes
  ],
  { useHash: true }
);



// WEBPACK FOOTER //
// ./src/app/routes.ts